import { ChevronRight } from 'lucide-react'
import type { SavedRecipe } from '../../lib/recipeTypes'

type Props = {
  recipe:  SavedRecipe
  onClick: (id: string) => void
}

export function CollectionRecipeCard({ recipe, onClick }: Props) {
  const pct    = recipe.ingredientCount > 0
    ? Math.round((recipe.ingredientsOnHand / recipe.ingredientCount) * 100)
    : 0
  const needed = recipe.ingredientsNeeded.length

  return (
    <button
      onClick={() => onClick(recipe.id)}
      className="w-full mb-[10px] overflow-hidden rounded-[18px] border border-border-sand bg-paper text-left"
    >
      <div className="h-1 bg-[#C5B89A]" />
      <div className="px-4 py-[14px] flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="font-serif text-[17px] font-medium tracking-[-0.01em] text-ink leading-[1.2]">
            {recipe.name}
          </h3>
          <p className="text-[11px] italic text-ink-muted mt-0.5">
            {recipe.ingredientCount} ingredient{recipe.ingredientCount === 1 ? '' : 's'}
            {recipe.prepMinutes > 0 ? ` · ${recipe.prepMinutes} min` : ''}
            {' · '}serves {recipe.serves}
          </p>

          <div className="mt-3 flex items-center gap-2">
            <div className="flex-1 h-[6px] rounded-[3px] bg-[#F0EBE0] overflow-hidden">
              <div
                className="h-full bg-terracotta transition-[width] duration-300"
                style={{ width: `${pct}%` }}
              />
            </div>
            <span className="text-[11px] text-ink-muted font-semibold">
              {recipe.ingredientsOnHand} / {recipe.ingredientCount}
            </span>
          </div>

          {needed > 0 && (
            <p className="text-[11px] italic text-terracotta mt-1">
              {needed} ingredient{needed === 1 ? '' : 's'} need shopping
            </p>
          )}
        </div>
        <ChevronRight className="h-[14px] w-[14px] text-ink-muted mt-1 flex-shrink-0" strokeWidth={1.6} />
      </div>
    </button>
  )
}
